import React, { useEffect, useState, useCallback, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { MdOutlineModeEditOutline } from "react-icons/md";
import { HiOutlinePlus, HiOutlinePhotograph } from "react-icons/hi";
import { ShimmerThumbnail } from "react-shimmer-effects";
import axios from "axios";
import { connect } from "react-redux";
import "./style.css";
import DeskTopView from "../Desktopview";
import baseUrlNew from "../BaseUrl/index";
import CarDamgeCamra from "../CarDamgeCamra";
import { getcardata } from "../Redux/reduxflow/action";
import Camra2 from "../Camra2";
import Camra from "../Camra";
import placeholderImage from "../assets/images/carnew.jpg";
import RotateDeviceScreen from "../components/RotateDeviceScreen";
import InspectionShell from "../components/InspectionShell";
import {
  getViewportScreenMode,
  subscribeViewportOrientation,
} from "../utils/viewportOrientation";
import { useMobilePhotoDevice } from "../utils/isMobilePhotoDevice";
import { sanitizeImageUrl } from "../utils/sanitizeImageUrl";

const PHOTO_SECTIONS = [
  {
    key: "exterior",
    title: "Exterior",
    type: "exterior",
    dataKey: "exterior_images_",
    slots: [
      "Front Driver Corner",
      "Rear Driver Corner",
      "Rear Passenger Corner",
      "Front Passenger Corner",
    ],
  },
  {
    key: "interior",
    title: "Interior",
    type: "interior",
    dataKey: "interior_images_",
    slots: ["Boot Interior", "Back Seats", "Dashboard", "Front Seats"],
  },
  {
    key: "treads",
    title: "Treads",
    type: "treads",
    dataKey: "treads_images_",
    slots: [
      "Front Passenger Tyre Tread",
      "Front Driver Tyre Tread",
      "Rear Driver Tyre Tread",
      "Rear Passenger Tyre Tread",
    ],
  },
  {
    key: "wheels",
    title: "Wheels",
    type: "Wheels",
    dataKey: "wheels_images_",
    slots: [
      "Front Passenger Alloys",
      "Front Driver Alloys",
      "Rear Passenger Alloys",
      "Rear Driver Alloys",
    ],
  },
];

const TITLE_TO_INDEX = {
  "Front Driver Corner": 0,
  "Rear Driver Corner": 1,
  "Rear Passenger Corner": 2,
  "Front Passenger Corner": 3,
  "Front Passenger Alloys": 4,
  "Front Passenger Tyre Tread": 5,
  "Front Driver Alloys": 6,
  "Front Driver Tyre Tread": 7,
  "Rear Driver Alloys": 8,
  "Rear Driver Tyre Tread": 9,
  "Rear Passenger Alloys": 10,
  "Rear Passenger Tyre Tread": 11,
  "Boot Interior": 12,
  "Back Seats": 13,
  Dashboard: 14,
  "Front Seats": 15,
};

function CarDamage({ getcardata, car_data, loading, id, car_name }) {
  const history = useHistory();
  const [sreen, setsreen] = useState(getViewportScreenMode);
  const isMobileDevice = useMobilePhotoDevice();
  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [recapture, setreCapture] = useState(false);
  const [imge, setImge] = useState(placeholderImage);
  const [image_id, setimage_id] = useState("");
  const [camra_open, setcamra_open] = useState(false);
  const [damgecamra, setdamgecamra] = useState(true);
  const [img_type, setimg_type] = useState();
  const [imge_categary, setimge_categary] = useState();
  const [captureBlocked, setCaptureBlocked] = useState(false);

  const PostCarimge = useCallback(() => {
    axios
      .get(
        `${baseUrlNew.baseUrl}api/v1/product_images_Details/${encodeURIComponent(
          String(id)
        )}`
      )
      .then((response) => {
        getcardata(response.data);
      })
      .catch(() => {});
  }, [id, getcardata]);

  useEffect(() => {
    PostCarimge();
  }, [PostCarimge]);

  useEffect(() => subscribeViewportOrientation(setsreen), []);

  const goSteps = () => {
    history.push({
      pathname: "/inspection/carsteps",
      state: { id, car_name },
    });
  };

  const requireMobileCapture = () => {
    if (!isMobileDevice) {
      setCaptureBlocked(true);
      return false;
    }
    setCaptureBlocked(false);
    return true;
  };

  const openImageViewer = useCallback((data, index) => {
    setCurrentImage(index);
    setimage_id(data);
    setImge(sanitizeImageUrl(data.image));
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setIsViewerOpen(false);
  };

  const take_imge = () => {
    if (!requireMobileCapture()) return;
    setreCapture(true);
  };

  const add_extrier = (current, type) => {
    if (!requireMobileCapture()) return;
    setimg_type(type);
    setimge_categary(current);
    setcamra_open(true);
  };

  const photoCount = useMemo(() => {
    if (!car_data || typeof car_data !== "object") return 0;
    return PHOTO_SECTIONS.reduce((sum, section) => {
      const list = car_data[section.dataKey];
      return sum + (Array.isArray(list) ? list.length : 0);
    }, 0);
  }, [car_data]);

  const findSlot = (list, name) => {
    if (!Array.isArray(list)) return { found: false, index: -1, item: null };
    const index = list.findIndex((row) => row?.name === name);
    return {
      found: index >= 0,
      index,
      item: index >= 0 ? list[index] : null,
    };
  };

  const renderSlot = (section, slotName) => {
    const list = car_data?.[section.dataKey] || [];
    const { found, index, item } = findSlot(list, slotName);

    if (found && item) {
      return (
        <button
          type="button"
          className="pi-photo-review__card"
          onClick={() => openImageViewer(item, index)}
        >
          <span className="pi-photo-review__media">
            <img src={sanitizeImageUrl(item.image)} alt={slotName} />
            <span className="pi-photo-review__edit" aria-hidden>
              <MdOutlineModeEditOutline size={16} />
            </span>
          </span>
          <span className="pi-photo-review__label">{slotName}</span>
        </button>
      );
    }

    return (
      <button
        type="button"
        className="pi-photo-review__card pi-photo-review__card--empty"
        onClick={() => add_extrier(slotName, section.type)}
      >
        <span className="pi-photo-review__media pi-photo-review__media--empty">
          <HiOutlinePlus size={22} />
          <span>Add photo</span>
        </span>
        <span className="pi-photo-review__label">{slotName}</span>
      </button>
    );
  };

  // Capture flows — mobile only (cameras still enforce landscape themselves)
  if (captureBlocked || ((!damgecamra || camra_open || recapture) && !isMobileDevice)) {
    return (
      <DeskTopView
        onBack={() => {
          setCaptureBlocked(false);
          setcamra_open(false);
          setreCapture(false);
          setdamgecamra(true);
          setIsViewerOpen(false);
        }}
      />
    );
  }

  if (!damgecamra) {
    return <CarDamgeCamra id={id} close={setdamgecamra} />;
  }

  if (camra_open) {
    return (
      <Camra2
        id={id}
        setcamra_open={setcamra_open}
        img_type={img_type}
        imge_categary={imge_categary}
        index_of_data={TITLE_TO_INDEX[imge_categary]}
      />
    );
  }

  if (recapture) {
    if (sreen !== "landscap") {
      return (
        <RotateDeviceScreen
          onBack={() => {
            setreCapture(false);
            setIsViewerOpen(true);
          }}
          description="Hold your phone horizontally to retake this photo."
        />
      );
    }
    return (
      <Camra
        data={image_id}
        index={currentImage}
        state={setreCapture}
        view={setIsViewerOpen}
      />
    );
  }

  // Review grid — available on desktop and mobile (no device / orientation lock)
  return (
    <InspectionShell
      badge="Car damages"
      title={car_name || "Vehicle"}
      onBack={goSteps}
      mainClassName="pi-inspection-main--dashboard"
      className="pi-inspection-page--app"
      showFooter
    >
      <div className="pi-photo-review">
        <header className="pi-photo-review__hero">
          <div>
            <p className="pi-inspection-label">Photo review</p>
            <h1>Review your photos</h1>
            <p>
              Check captured angles, add missing slots, or retake any photo from
              a mobile device.
            </p>
          </div>
          <div className="pi-photo-review__stat">
            <HiOutlinePhotograph size={22} aria-hidden />
            <div>
              <strong>{photoCount}</strong>
              <span>captured</span>
            </div>
          </div>
        </header>

        {loading ? (
          <div className="pi-photo-review__loading">
            {PHOTO_SECTIONS.map((section) => (
              <section key={section.key} className="pi-photo-review__section">
                <div className="pi-photo-review__section-head">
                  <ShimmerThumbnail height={28} width={140} rounded />
                </div>
                <div className="pi-photo-review__grid">
                  {section.slots.map((slot) => (
                    <div key={slot} className="pi-photo-review__shimmer">
                      <ShimmerThumbnail height={140} rounded />
                    </div>
                  ))}
                </div>
              </section>
            ))}
          </div>
        ) : (
          PHOTO_SECTIONS.map((section) => (
            <section key={section.key} className="pi-photo-review__section">
              <div className="pi-photo-review__section-head">
                <h2>{section.title}</h2>
                <span>
                  {
                    (car_data?.[section.dataKey] || []).length
                  }{" "}
                  / {section.slots.length}
                </span>
              </div>
              <div className="pi-photo-review__grid">
                {section.slots.map((slot) => (
                  <React.Fragment key={slot}>
                    {renderSlot(section, slot)}
                  </React.Fragment>
                ))}
              </div>
            </section>
          ))
        )}
      </div>

      {isViewerOpen ? (
        <div className="pi-photo-review__lightbox" role="dialog" aria-modal="true">
          <div className="pi-photo-review__lightbox-bar">
            <button
              type="button"
              className="pi-photo-review__lightbox-btn"
              onClick={take_imge}
            >
              Re-capture
            </button>
            <button
              type="button"
              className="pi-photo-review__lightbox-btn pi-photo-review__lightbox-btn--ghost"
              onClick={closeImageViewer}
            >
              Close
            </button>
          </div>
          <img src={imge} alt="Vehicle photo preview" />
        </div>
      ) : null}
    </InspectionShell>
  );
}

const mapStateToProps = (state) => ({
  car_data: state.cardata.car_pics_data,
  loading: state.cardata.loadingdamage,
});
const mapDispatchToProps = (dispatch) => ({
  getcardata: (response) => dispatch(getcardata(response)),
});
export default connect(mapStateToProps, mapDispatchToProps)(CarDamage);
